/** Pharmacy logos bundled with the app, keyed by directory id. */
export const pharmacyLogoImages: Record<string, number> = {
  "org-pharmacy-freedom":
    require("../../../assets/images/pharmacy-logos/freedom-fertility.png") as number,
  "org-pharmacy-mdr":
    require("../../../assets/images/pharmacy-logos/mdr-specialty-pharmacy.png") as number,
  "org-pharmacy-alto":
    require("../../../assets/images/pharmacy-logos/alto.png") as number,
  "org-pharmacy-vfp":
    require("../../../assets/images/pharmacy-logos/vfp.png") as number,
  "org-pharmacy-apri":
    require("../../../assets/images/pharmacy-logos/apri.png") as number,
  "org-pharmacy-prima":
    require("../../../assets/images/pharmacy-logos/prima.png") as number,
  "org-pharmacy-mandells":
    require("../../../assets/images/pharmacy-logos/mandells.png") as number,
  "org-pharmacy-smp":
    require("../../../assets/images/pharmacy-logos/smp.png") as number,
  "org-pharmacy-cvs-specialty":
    require("../../../assets/images/pharmacy-logos/cvs-specialty.png") as number,
  "org-pharmacy-walgreens-specialty":
    require("../../../assets/images/pharmacy-logos/walgreens.png") as number,
  "org-pharmacy-metro-drugs":
    require("../../../assets/images/pharmacy-logos/metro-drugs.png") as number,
  "org-pharmacy-apthorp":
    require("../../../assets/images/pharmacy-logos/apthorp.png") as number,
  "org-pharmacy-rosemont":
    require("../../../assets/images/pharmacy-logos/rosemont.jpg") as number,
  "org-pharmacy-fuze":
    require("../../../assets/images/pharmacy-logos/fuze-health.png") as number,
};
